(function ($, Drupal) {

  Drupal.behaviors.initComments = {
    attach: function (context, settings) {

      $('.js_comments', context).once('initComments').each(function () {

        let $el = $(this),
            $wrap = $el.find('.comments__list'),
            $comment = $wrap.find('.comment'),
            $pagination = $el.find('.comments__pagination'),
            $prev = $pagination.find('.comments__prev'),
            $next = $pagination.find('.comments__next'),
            $counter = 0,
            $step = 8, // How many comments to show per page (production 10, test 8)
            $pages = Math.ceil($comment.length/$step);

        if ($pages > 1) {
          $pagination.addClass('is-active');
        }

        function setComments() {
          $comment.removeClass('is-active');
          $comment.slice(($counter*$step),($counter*$step)+$step).addClass('is-active');
        }

        function checkCounter() {
          if ($counter < 0) {
            $counter = $pages - 1;
          } else if ($counter > $pages - 1) {
            $counter = 0;
          }
          setComments();
        }

        $prev.on('click', function(evt) {
          evt.preventDefault();
          $counter -= 1;
          checkCounter();
        });

        $next.on('click', function(evt) {
          evt.preventDefault();
          $counter += 1;
          checkCounter();
        });

        setComments();

      });

    }
  };

})(jQuery, Drupal);
